import { IntegrationComponent } from "components/IntegrationComponent";
import { VACATION_STRINGS } from "shared/constants/vacationStrings";

import { RequestsTable } from "./components/RequestsTable";

const VacationRequests = () => {
  return (
    <IntegrationComponent
      message={VACATION_STRINGS.INTEGRATION_MESSAGE}
      confirmButtonLabel={VACATION_STRINGS.INTEGRATION_CONFIRM_BUTTON_LABEL}
    >
      <section
        className="h-full w-full border rounded-md shadow-2xl p-1"
        aria-label="Solicitudes de vacaciones"
        data-testid="vacation-requests-section"
      >
        <RequestsTable />
      </section>
    </IntegrationComponent>
  );
};

export default VacationRequests;
